import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { plainToClass } from 'class-transformer';

import { environment } from '../../../environments/environment';
import { ProgressIndicatorService } from './progress-indicator.service';
import { CollectApiServiceBase } from './collect-api-base.service';
import { DisplayTimeAndHoursOffset } from '../models/misc-metadata/display-time-and-hours-offset.model';

@Injectable()
export class MiscellaneousMetadataService extends CollectApiServiceBase<DisplayTimeAndHoursOffset> {
    // Instance data.
    private displayTimes: DisplayTimeAndHoursOffset[] = null;

    // Constructor.
    public constructor(http: HttpClient, progressIndicatorService: ProgressIndicatorService) {
        super(http, progressIndicatorService, environment.apiUrl, 'miscellaneousMetadata', DisplayTimeAndHoursOffset)
    }

    // Overrides.
    // None at this time.

    // Service methods.
    // Metadata method(s).
    public getDisplayTimes(): Promise<DisplayTimeAndHoursOffset[]> {
        if (this.displayTimes == null) {
            let url = `${this.url}/${this.endpoint}/getDisplayTimes`;

            return this.http.get<DisplayTimeAndHoursOffset[]>(url)
                .toPromise()
                .then(response => {
                    this.displayTimes = [];

                    if (response != null) {
                        for (let iTime: number = 0; iTime < response.length; iTime++) {
                            let oTime = response[iTime];
                            let time: DisplayTimeAndHoursOffset = plainToClass(DisplayTimeAndHoursOffset, oTime);

                            this.displayTimes.push(time);
                        }
                    }

                    return this.displayTimes;
                })
                .catch(this.handleError);
        } else {
            let result: Promise<DisplayTimeAndHoursOffset[]> = new Promise(this.resolveDisplayTimes);

            return result;
        }
    }

    // Helper methods.
    private resolveDisplayTimes = (resolve, reject) => {
        resolve(this.displayTimes);
    }
}
